const SP_REPORT_TYPES = {
  SALES_TRAFFIC_REPORT: "SALES_TRAFFIC_REPORT",
  SALES_GEO_REPORT: "SALES_GEO_REPORT",
  VENDOR_SALES_REPORT: "VENDOR_SALES_REPORT",
}

export {
  SP_REPORT_TYPES
}